import { render } from "./ArticleListComponent.vue?vue&type=template&id=22d55aa0"
import script from "./ArticleListComponent.vue?vue&type=script&lang=js"
export * from "./ArticleListComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/kinarya-jqdev/jqdev/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__